import { autoinspectorApi } from '@autoinspector/providers/autoinspector'
import { ErrorInfo } from 'react'
import * as Yup from 'yup'
import axios from 'axios'
import { parse } from 'query-string'

const querySchema = Yup.object({
  accessCode: Yup.string().required(),
})

export const registerInspectionError = (
  error: Error,
  errorInfo?: ErrorInfo,
) => {
  const query = parse(window.location.search)
  const pathParameter = window.location.pathname

  const isInspectionError =
    querySchema.isValidSync(query) && pathParameter.startsWith('/inspection/')

  console.log(
    '[registerInspectionError] isInspectionError',
    isInspectionError,
    'error',
    error,
  )

  if (isInspectionError) {
    const pathSegments = pathParameter.split('/')
    const inspectionId = pathSegments[pathSegments.length - 1]

    autoinspectorApi
      .POST('/v1/inspection/client/{inspectionId}/error', {
        body: {
          stack: errorInfo?.componentStack || error.stack,
          message: error.message,
          name: error.name,
          url: window.location.href,
          runtime: 'client',
        },
        params: {
          path: {
            inspectionId,
          },
          header: {
            access_code: query.accessCode,
          },
        },
      })
      .catch(console.error)
  }

  if (!isInspectionError) {
    axios
      .post('/api/register/error', {
        componentStack: errorInfo?.componentStack,
        error: error.stack,
      })
      .catch(console.error)
  }
}
